import { GET_FAQS } from "../actions/types";

const initialState = {
  faqs: [],
};

export default function faqReducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case GET_FAQS:
      return {
        ...state,
        faqs: action.faqs,
      };
    default:
      return {
        ...state,
      };
  }
}
